
import './App.css';
import Tictactoe from './Components/Tictactoe/Tictactoe';

function App() {
  return (
    <div className="App">
     <Tictactoe/>
    </div>
  );
}

export default App;
